export default __webpack_public_path__ + "static/media/Assessment_Info_Card.50753f99.svg";